import React, { useEffect, useState } from 'react';
import { convertRestIdToEwsId } from 'owa-identifiers';
import { Navigate, useSearchParams } from 'mini-react-router-dom';
import getItemFromIMId from 'owa-mail-store/lib/services/getItemFromIMId';

export const MailJsmvvmDeepLinkHandler = () => {
    const [searchParams] = useSearchParams();
    const itemId = searchParams.get('ItemID');
    const internetMessageID = searchParams.get('InternetMessageID');

    const [resolvedItemId, setResolvedItemId] = useState(null);

    useEffect(() => {
        if (itemId || internetMessageID) {
            resolveItemId(itemId, internetMessageID, setResolvedItemId);
        }
    }, [itemId, internetMessageID]);

    return resolvedItemId ? <Navigate to={`/read/${resolvedItemId}`} replace /> : null;
};

// Utility function to resolve the item ID
const resolveItemId = async (itemId, internetMessageID, setResolvedItemId) => {
    let ewsId = '';

    if (itemId) {
        ewsId = convertRestIdToEwsId(itemId);
    } else if (internetMessageID) {
        const fetchedItemId = await getItemFromIMId(internetMessageID);
        ewsId = convertRestIdToEwsId(fetchedItemId);
    }

    setResolvedItemId(encodeURIComponent(ewsId));
};
